import React from "react";
import { ProductCard } from "../product/ProductCard";
import { cn, getSizedImage } from "@/helpers/utils";
import { DroppsProduct, productSelect, variantSelect } from "@/store";

type ListProps = {
  products: DroppsProduct[];
  title: string;
};

const List = ({ products, title }: ListProps) => {
  if (products.length < 1) {
    return null;
  } else {
    return (
      <div>
        <h3 className="subtitle px-4 py-6 text-base font-bold">{title}</h3>
        <ul>
          {products.map((product) => {
            const variant = productSelect.defaultVariant(product);
            const mappedProduct = {
              id: variant.id,
              featuredImage: {
                src: getSizedImage(
                  productSelect.featuredImage(product).url,
                  "x440"
                ),
                height: 440,
                width: 549,
              },
              title: product.title,
              size: variantSelect.sizeFormat(variant),
              compareAtPrice: variant?.compareAtPrice,
              product,
              variant,
            };
            return (
              <li key={product.title}>
                <hr className="divider-x mx-4 my-0" />
                <ProductCard
                  className="rounded-none"
                  productCardValue={mappedProduct}
                  compact={true}
                  hoverable={false}
                />
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
};

type BundleProductListProps = {
  products: DroppsProduct[];
  className?: string;
};

export const BundleProductList = ({
  products,
  className,
}: BundleProductListProps) => {
  const laundryProducts = products.filter(
    (product: DroppsProduct) =>
      product.type === "Laundry" || product.type === "Laundry & Household"
  );
  const dishProducts = products.filter(
    (product: DroppsProduct) =>
      product.type === "Dish" || product.type === "Household"
  );

  return (
    <div className={cn("bg-white", className)}>
      <List products={laundryProducts} title="Laundry Products" />
      <List products={dishProducts} title="Dish Products" />
    </div>
  );
};
